import ExpertProfileReviewsEditModalModule from './expert-profile-reviews-edit-modal.module'

export default ExpertProfileReviewsEditModalModule
